import React from "react";
import "../media/css/resume.css";

const Resume = () => {
  // sub dates
  const softwareSkills = [
    { title: "Photoshop", progress: 90 },
    { title: "Illustrator", progress: 80 },
    { title: "Figma", progress: 85 },
    { title: "After Effects", progress: 75 },
    { title: "Blender", progress: 70 },
  ];
  const languages = [
    { title: "English", progress: 95 },
    { title: "Spanish", progress: 60 },
    { title: "Russian", progress: 80 },
  ];
  const experience = [
    { year: "2021", company: "WHITE FISH ADVERTISING CO.", role: "Art Design" },
    {
      year: "2020",
      company: "BLUE OCEAN MARKETING LTD.",
      role: "Graphic Design",
    },
    {
      year: "2019",
      company: "GOLDEN SUN CREATIVE AGENCY",
      role: "Brand Identity",
    },
    { year: "2018", company: "RED SKY DIGITAL SOLUTIONS", role: "Web Design" },
    {
      year: "2017",
      company: "GREEN LEAF MEDIA GROUP",
      role: "Motion Graphics",
    },
  ];
  const designSkills = [
    "Graphic Design",
    "Web Design",
    "Illustration",
    "Motion Graphics",
    "Social Media Design",
    "Print Design",
    "Packaging Design",
    "Content Strategy",
  ];
  const personalSkills = ["Creative", "Teamwork", "Engineering"];
  const hobbies = [
    "Game Developing",
    "Animation",
    "Concept Art",
    "Sketching",
    "3D Animation",
  ];
  const capabilities = [
    "Logo",
    "Branding",
    "Advertisement",
    "Strategy",
    "UI/UX",
    "Brandbook",
  ];

  // sub components
  const SectionTitle = ({ title }) => (
    <div className="col-title">
      <p>{title}</p>
    </div>
  );

  const SkillRow = ({ title, progress }) => (
    <div className="row">
      <div className="title">{title}</div>
      <div className="progress-bar">
        <div className="progress">
          <div className="crc" style={{ marginLeft: `${progress}%` }}></div>
        </div>
      </div>
    </div>
  );

  const ExperienceRow = ({ year, company, role }) => (
    <div className="row">
      <div className="year">{year}</div>
      <div className="title">
        <p>{company}</p>
        <span>{role}</span>
      </div>
    </div>
  );

  return (
    <section id="resume" className="section-resume">
      <div className="layer"></div>
      <div className="container">
        <div className="grid">
          {/* Col 1 - Skills */}
          <div className="col c1">
            <SectionTitle title="SOFTWARE SKILLS" />
            <div className="group skills">
              {softwareSkills.map((skill, index) => (
                <SkillRow
                  key={index}
                  title={skill.title}
                  progress={skill.progress}
                />
              ))}
            </div>

            <SectionTitle title="LANGUAGES" />
            <div className="group languages">
              {languages.map((language, index) => (
                <SkillRow
                  key={index}
                  title={language.title}
                  progress={language.progress}
                />
              ))}
            </div>

            <SectionTitle title="PERSONAL SKILLS" />
            <div className="group personal-skills">
              <p>{personalSkills.join(", ")}</p>
            </div>
          </div>

          {/* Col 2 - Experience & Education */}
          <div className="col c2">
            <SectionTitle title="EXPERIENCE" />
            <div className="group exp">
              {experience.map((exp, index) => (
                <ExperienceRow key={index} {...exp} />
              ))}
            </div>

            <SectionTitle title="EDUCATION" />
            <div className="group edu">
              <div className="title">
                <p>HIGHLAND ART SCHOOL</p>
                <span>Fine Arts & Illustration</span>
              </div>
            </div>
          </div>

          {/* Col 3 - Additional Skills & Interests */}
          <div className="col c3">
            <SectionTitle title="WHAT CAN I DO?" />
            <div className="group can list">
              {capabilities.map((capability, index) => (
                <span key={index}>{capability}</span>
              ))}
            </div>

            <SectionTitle title="DESIGN SKILLS" />
            <div className="group design-skills list">
              {designSkills.map((skill, index) => (
                <span key={index}>{skill}</span>
              ))}
            </div>

            <SectionTitle title="HOBBIES & INTERESTS" />
            <div className="group hobbies list">
              {hobbies.map((hobby, index) => (
                <span key={index}>{hobby}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
